import React from 'react';
import KemanusiaanIcon from '../CategoryImages/feature_1.png'
import '../CategoryBanner/categorybanner.css'

const BannerKemanusiaan = () => {
    return (
        <div className="banner-category">
            <div className="banner-category-row">
                <img src={KemanusiaanIcon} alt="" width="100" />
                <div className="banner-category-column">
                    <h5 className="banner-name">Kemanusiaan</h5>
                    <p className="banner-name-txt">Donasi Terbuka</p>
                </div>
            </div>
        </div>
    )
}

export default BannerKemanusiaan;